
import * as Dto                          from '../dtos'; 
import { ProxyHttp } from '@wtw/platform/api';
import { Injectable }                    from '@angular/core';
import { Observable }                    from 'rxjs';
import { ApiResult,BinaryTransferObject} from '@wtw/platform/api';
import { map }                           from  'rxjs/operators';
export { ApiResult };

@Injectable()
export class NegotiationAnalysisProxy {
    	constructor(private _http: ProxyHttp) { 
        }
        
             
                updateSummaryTotals (summaryInputs: Dto.CarrierAssessmentSummaryInput) : Observable<ApiResult<Dto.CarrierAssessmentSummaryInput>> {
                return this._http.post(`/backend/negotiationAnalysis/updateSummaryTotals`,summaryInputs||{}).pipe(map(ret=>({ data: ret.body, originalResponse: ret})));
	        }
             
        
}

	
